<template>
  <div class="main">
     <TopCtrl/>
    <ProductListFilter :search="query" 
      :affordable="filterByMyPoint" 
      :orderType="orderType" 
      :direction="direction"
      @onChange="onFilterChange"
      @onSearch="onSearch"/>
      <ListView :on-infinite="onLoadMore"
                  :hasMore="hasMore"
                  :isEmpty="productList.length <= 0">
        <div class="product-list">
          <ProductItem v-for="p in productList" :key="'h-'+p.productId" :type="'normal'" :product="p"/>
        </div>
      </ListView>

      <template v-if="user.kkbUser && user.kubaoLotteryLoginUrl">
        <GameEmptyListTip
          v-if="ready && productList.length <= 0"
          :icon="require('../../assets/icon-empty-products.png')"
          :url="user.kubaoLotteryLoginUrl"
          />
      </template>
      <template v-else>
        <EmptyListTip
          v-if="ready && productList.length <= 0"
          :icon="require('../../assets/icon-empty-products.png')"
          :text=" filterByMyPoint ?  '暂无满足兑换条件的商品' :'暂无此类商品，去首页看看吧'"
          />
      </template>
    

    <!-- <TabBar active="products"></TabBar> -->
  </div>
  
</template>

<script>
import api from '../../api'
import store from '../../api/store'
import ProductListFilter from '@/components/products/ProductListFilter'
import GameEmptyListTip from '@/components/kubaolottery/GameEmptyListTip'

var loadDataTimer = null;

export default {
  title: '商品列表',
  bodyClass: 'gray-bg',
  keepAlive: true,
  components: {ProductListFilter, GameEmptyListTip},
  data () {
    return {
      init: false,
      categoryId: null,
      tagGroupId: null, 
      tagId: null,
      query: '',
      orderType: '',//sale, price
      direction: 2, //ASC(1), DESC(2)
      filterByMyPoint: false,
      lastId: '',
      limit: 8,
      hasMore: true,
      ready: false,
      productList :[
        // {productId: 0, gainCount: 10, name: '越南进口 中原G7三合一速溶咖啡1600g', price: 1200, img:'https://m.360buyimg.com/babel/s422x422_jfs/t2932/279/759495863/243388/5086177e/57677d33Ned8dbfd5.jpg'}
      ],
      user: {
        kkbUser: store.loginedUser.kkbUser,
        kubaoLotteryLoginUrl: store.loginedUser.kubaoLotteryLoginUrl,
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...

      var p1 = from.fullPath.split('#')[0];
      var p2 = to.fullPath.split('#')[0];
      if(p1 != p2){ //仅路径发生变化时，才重新加载
        console.log('路由变化');
        this.onMounted();
      }
      
    }
  },
  methods: {
    onMounted(doneCb){
      if(!doneCb){
        doneCb = ()=>{}
      }
      //处理请求参数
      if(this.$route.query.categoryId){
        this.categoryId = this.$route.query.categoryId;
      }else{
        this.categoryId = null;
      }

      if(this.$route.query.tagGroupId){
        this.tagGroupId = this.$route.query.tagGroupId;
      }else{
        this.tagGroupId = null;
      }

      if(this.$route.query.tagId){
        this.tagId = this.$route.query.tagId;
      }else{
        this.tagId = null;
      }

      if(this.$route.query.q){
        this.query = this.$route.query.q;
      }else{
        this.query = '';
      }

      if(this.$route.query.affordable){
        this.filterByMyPoint = this.$route.query.affordable == '1';
      }else{
        this.filterByMyPoint = false;
      }
      
      //加载数据
      this.$showLoading('加载中...');
      this.loadData(true, doneCb);
    },
    loadData(isNew, doneCb){
      
      if(!doneCb){
        doneCb = ()=>{}
      }

      if(isNew){//重新加载列表
        this.ready = false;
        this.productList = [];
        this.lastId = '';
        this.hasMore = true;
      }

      api.product.getSkuList(this.categoryId, this.tagGroupId, this.tagId, this.query, this.orderType, this.direction, this.filterByMyPoint, this.lastId, this.limit, res=>{
        console.log(res);
        res.list.forEach(p => {
          this.productList.push({
            productId: p.skuId, 
            gainCount: p.soldCount, 
            name: p.name, 
            title: p.title, 
            price: p.price, 
            img: p.image
            });  
        });
        this.hasMore = res.hasMore;
        this.lastId = res.lastId;
        this.ready = true;
        this.$hideLoading();
        doneCb();
      }, r=>{
        this.$alertDialog(r.msg);
        this.$hideLoading();
        doneCb();
      })
    },
    onFilterChange(search, affordable, orderType, direction){
      console.log('onFilterChange');
      this.query = search;
      this.filterByMyPoint = affordable;
      this.orderType = orderType;
      this.direction = direction;
      
      if(this.init){ //由于恢复数据可能会产生多次调用，所以设置了init标记初始化过程
        //延时加载，保护接口
        this.$showLoading('加载中...');
        clearTimeout(loadDataTimer);
        loadDataTimer = setTimeout(()=>{
          this.loadData(true);
        }, 1000);
      }
      
    },
    onSearch(query){
      this.query = query;
      this.loadData(true);
    },
    onLoadMore(done){
      this.loadData(false, done);
    }
  },
  mounted(){
    //恢复
    api.pagestate.recover(this, ()=>{
      console.log('init data');
      this.onMounted(()=>{
        this.init = true;
      });
    }, ()=>{
      //重置 init
      setTimeout(()=>{
        this.init = true;
      }, 10);
      
    });
    //设置标记
    this.init = false;
    
    
  }
};
</script>

<style scoped lang="less">

.main{
  // max-height: 100vh;
  // overflow: auto;
}

.product-list{
  text-align: center;
}

.wrap {
	position: unset;
}


</style>



// WEBPACK FOOTER //
// src/pages/products/List.vue